import i18n from "i18next"
import { initReactI18next } from "react-i18next"

import enCommon from "@/locales/en/common.json"
import enDashboard from "@/locales/en/dashboard.json"
import enDailyLog from "@/locales/en/dailyLog.json"
import enMedications from "@/locales/en/medications.json"
import enCalendar from "@/locales/en/calendar.json"
import enSettings from "@/locales/en/settings.json"
import enAICompanion from "@/locales/en/aiCompanion.json"
import enAssessment from "@/locales/en/assessment.json"
import frCommon from "@/locales/fr/common.json"
import frDashboard from "@/locales/fr/dashboard.json"
import frDailyLog from "@/locales/fr/dailyLog.json"
import frMedications from "@/locales/fr/medications.json"
import frCalendar from "@/locales/fr/calendar.json"
import frSettings from "@/locales/fr/settings.json"
import frAICompanion from "@/locales/fr/aiCompanion.json"
import frAssessment from "@/locales/fr/assessment.json"
import esCommon from "@/locales/es/common.json"
import esDashboard from "@/locales/es/dashboard.json"
import esDailyLog from "@/locales/es/dailyLog.json"
import esMedications from "@/locales/es/medications.json"
import esCalendar from "@/locales/es/calendar.json"
import esSettings from "@/locales/es/settings.json"
import esAICompanion from "@/locales/es/aiCompanion.json"
import esAssessment from "@/locales/es/assessment.json"
import deCommon from "@/locales/de/common.json"
import deDashboard from "@/locales/de/dashboard.json"
import deDailyLog from "@/locales/de/dailyLog.json"
import deMedications from "@/locales/de/medications.json"
import deCalendar from "@/locales/de/calendar.json"
import deSettings from "@/locales/de/settings.json"
import deAICompanion from "@/locales/de/aiCompanion.json"
import deAssessment from "@/locales/de/assessment.json"
import itCommon from "@/locales/it/common.json"
import itDashboard from "@/locales/it/dashboard.json"
import itDailyLog from "@/locales/it/dailyLog.json"
import itMedications from "@/locales/it/medications.json"
import itCalendar from "@/locales/it/calendar.json"
import itSettings from "@/locales/it/settings.json"
import itAICompanion from "@/locales/it/aiCompanion.json"
import itAssessment from "@/locales/it/assessment.json"
import ptCommon from "@/locales/pt/common.json"
import ptDashboard from "@/locales/pt/dashboard.json"
import ptDailyLog from "@/locales/pt/dailyLog.json"
import ptMedications from "@/locales/pt/medications.json"
import ptCalendar from "@/locales/pt/calendar.json"
import ptSettings from "@/locales/pt/settings.json"
import ptAICompanion from "@/locales/pt/aiCompanion.json"
import ptAssessment from "@/locales/pt/assessment.json"
import nlCommon from "@/locales/nl/common.json"
import nlDashboard from "@/locales/nl/dashboard.json"
import nlDailyLog from "@/locales/nl/dailyLog.json"
import nlMedications from "@/locales/nl/medications.json"
import nlCalendar from "@/locales/nl/calendar.json"
import nlSettings from "@/locales/nl/settings.json"
import nlAICompanion from "@/locales/nl/aiCompanion.json"
import nlAssessment from "@/locales/nl/assessment.json"
import plCommon from "@/locales/pl/common.json"
import plDashboard from "@/locales/pl/dashboard.json"
import plDailyLog from "@/locales/pl/dailyLog.json"
import plMedications from "@/locales/pl/medications.json"
import plCalendar from "@/locales/pl/calendar.json"
import plSettings from "@/locales/pl/settings.json"
import plAICompanion from "@/locales/pl/aiCompanion.json"
import plAssessment from "@/locales/pl/assessment.json"

export const defaultNS = "common"

const resources = {
  en: {
    common: enCommon,
    dashboard: enDashboard,
    dailyLog: enDailyLog,
    medications: enMedications,
    calendar: enCalendar,
    settings: enSettings,
    aiCompanion: enAICompanion,
    assessment: enAssessment,
  },
  fr: {
    common: frCommon,
    dashboard: frDashboard,
    dailyLog: frDailyLog,
    medications: frMedications,
    calendar: frCalendar,
    settings: frSettings,
    aiCompanion: frAICompanion,
    assessment: frAssessment,
  },
  es: {
    common: esCommon,
    dashboard: esDashboard,
    dailyLog: esDailyLog,
    medications: esMedications,
    calendar: esCalendar,
    settings: esSettings,
    aiCompanion: esAICompanion,
    assessment: esAssessment,
  },
  de: {
    common: deCommon,
    dashboard: deDashboard,
    dailyLog: deDailyLog,
    medications: deMedications,
    calendar: deCalendar,
    settings: deSettings,
    aiCompanion: deAICompanion,
    assessment: deAssessment,
  },
  it: {
    common: itCommon,
    dashboard: itDashboard,
    dailyLog: itDailyLog,
    medications: itMedications,
    calendar: itCalendar,
    settings: itSettings,
    aiCompanion: itAICompanion,
    assessment: itAssessment,
  },
  pt: {
    common: ptCommon,
    dashboard: ptDashboard,
    dailyLog: ptDailyLog,
    medications: ptMedications,
    calendar: ptCalendar,
    settings: ptSettings,
    aiCompanion: ptAICompanion,
    assessment: ptAssessment,
  },
  nl: {
    common: nlCommon,
    dashboard: nlDashboard,
    dailyLog: nlDailyLog,
    medications: nlMedications,
    calendar: nlCalendar,
    settings: nlSettings,
    aiCompanion: nlAICompanion,
    assessment: nlAssessment,
  },
  pl: {
    common: plCommon,
    dashboard: plDashboard,
    dailyLog: plDailyLog,
    medications: plMedications,
    calendar: plCalendar,
    settings: plSettings,
    aiCompanion: plAICompanion,
    assessment: plAssessment,
  },
}

if (!i18n.isInitialized) {
  i18n.use(initReactI18next).init({
    resources,
    lng: "en",
    fallbackLng: "en",
    defaultNS,
    interpolation: {
      escapeValue: false,
    },
  })
}

export default i18n
